/**
 * Checkout Discount Type Definitions
 *
 * Zod schemas and TypeScript types for discount data extracted from DaVinci BA response.
 * A rebate is a SalesPrices[] component flagged SeparateOnDocuments=true whose
 * per-room sum (collapsed by Text) is negative — see `pricingExtractor.ts`.
 */

import { z } from 'zod';

/**
 * A rebate of one room, collapsed from the DaVinci SalesPrices lines sharing its Text.
 *
 * Example DaVinci entry:
 * { Text: "Frühbucher-Vorteil", Price: -184.8, Amount: 1, PercentInput: -15,
 *   PriceType: 2, SeparateOnDocuments: true }
 */
export const ExtractedDiscountSchema = z.object({
  /** Discount name (e.g., "Frühbucher-Vorteil", "Sparvorteil ab 14 Nächten") */
  text: z.string(),
  /** Discount amount - always negative (e.g., -464.1) */
  amount: z.number().max(0),
  /** Discount percentage from PercentInput - normalized to positive 0-100 range */
  percent: z.number().min(0).max(100).optional(),
});

export type ExtractedDiscount = z.infer<typeof ExtractedDiscountSchema>;
